export enum PatientFileMark {
  GENERAL = 'GENERAL',
  // The former STATISTICS tab is merged into PROGRAM: the Programme tab renders
  // the program list first and the statistics below it.
  PROGRAM = 'PROGRAM',
  DIAGNOSIS = 'DIAGNOSIS',
  DOCUMENTATION = 'DOCUMENTATION',
}
